import React from 'react';
import { REFUND_POLICY } from '../utils/orderPricing';

export const RefundPolicy = ({ compact = false, id }) => (
  <div
    id={id}
    data-testid={compact ? 'order-refund-policy' : 'terms-refund-policy'}
    className={compact ? 'rounded-xl border border-white/10 bg-white/[0.03] p-5 scroll-mt-44' : 'scroll-mt-44'}
  >
    <h2 className={compact ? 'text-white font-semibold text-sm mb-3 uppercase tracking-wider' : 'text-2xl font-bold text-white mb-4'}>
      Cancellations and Refunds
    </h2>
    <div className="space-y-3">
      {REFUND_POLICY.map((p) => (
        <p key={p} className={compact ? 'text-gray-400 text-sm leading-relaxed' : 'text-gray-300 leading-relaxed'}>{p}</p>
      ))}
    </div>
  </div>
);

export default RefundPolicy;
